import { render, staticRenderFns } from "./waitingChallenges.vue?vue&type=template&id=0c5e8c9e&scoped=true"
import script from "./waitingChallenges.vue?vue&type=script&lang=js"
export * from "./waitingChallenges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5e8c9e",
  null
  
)

export default component.exports